/**
 * How many columns a chart tooltip needs so that all its rows fit the window.
 * Measures one rendered list: `listHeight` is its height with `listRows` rows
 * in its tallest column, `otherHeight` the rest of the card.
 */
export function chartTooltipColumns(input: {
  rows: number;
  listHeight: number;
  listRows: number;
  otherHeight: number;
  windowHeight: number;
}): number {
  const { rows, listHeight, listRows, otherHeight, windowHeight } = input;
  if (rows < 1 || listRows < 1 || listHeight <= 0) return 1;
  const perColumn = Math.floor(((windowHeight - otherHeight) * listRows) / listHeight);
  return Math.max(1, Math.ceil(rows / Math.max(1, perColumn)));
}
